module.exports = __webpack_public_path__ + "static/img/FJ.012ec034.png";